'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const DemoInner = dynamic(() => import('./AudienceDemographicsChartInner'), { ssr: false });

interface Props {
  platform: 'facebook' | 'instagram';
}

export default function AudienceDemographicsChart({ platform }: Props) {
  return <DemoInner platform={platform} />;
}